export default {
    list: {
        title: 'Libreta de Direcciones',
        subtitle: 'Gestiona tus contactos',
        addContact: 'Añadir Contacto',
        loading: 'Cargando contactos...',
        allRoles: 'Todos los roles',
        searchPlaceholder: 'Buscar por nombre, apellido o email...',
        rolePlaceholder: 'Filtrar por rol',
        description: 'Lista de contactos en tu libreta de direcciones',
        headers: {
            firstName: 'Nombre',
            lastName: 'Apellido',
            company: 'Empresa',
            email: 'Email',
            phone: 'Teléfono',
            role: 'Rol',
            actions: 'Acciones',
        },
        noContacts: {
            title: 'No se encontraron contactos',
            message: 'Intenta modificar los filtros de búsqueda',
            emptyMessage: 'Comienza añadiendo tu primer contacto',
            addFirst: 'Añadir Primer Contacto',
            companyTitle: 'No se encontraron contactos',
            companyMessage: 'Actualmente no hay personas asociadas a esta empresa',
            clearFilter: 'Limpiar Filtro',
        },
        modal: {
            addTitle: 'Añadir Contacto',
            editTitle: 'Editar Contacto',
            fields: {
                firstName: 'Nombre',
                firstNamePlaceholder: 'Ingresa nombre',
                lastName: 'Apellido',
                lastNamePlaceholder: 'Ingresa apellido',
                company: 'Empresa',
                companyPlaceholder: 'Ingresa nombre de la empresa',
                email: 'Email',
                emailPlaceholder: 'nombre@empresa.com',
                phone: 'Teléfono',
                phonePlaceholder: 'Ingresa número de teléfono',
                role: 'Rol',
                notes: 'Notas',
                notesPlaceholder: 'Añade notas adicionales sobre este contacto...',
            },
            cancel: 'Cancelar',
            save: 'Guardar Cambios',
            create: 'Añadir Contacto',
        },
        confirmDelete: {
            title: 'Confirmar eliminación',
            message: '¿Estás seguro de que quieres eliminar este contacto? Esta acción no se puede deshacer.',
            cancel: 'Cancelar',
            delete: 'Eliminar',
        },
    },
};

